module.exports = __webpack_public_path__ + "static/landing-bg-222214b236228831e27c336987fbb91a.jpeg";